import React, { FC, useMemo } from 'react'
import { ItemProps } from '../../types'
import ValidationError from '../ValidationError'
import SwitchControl from '@/components/UiElements/Switch'

const defaultOptions = [
	{ label: 'Close', value: false },
	{ label: 'Open', value: true },
]

const Switch: FC<ItemProps> = ({
	formItem,
	validation,
	disabled,
	formData,
	onChange,
	onFocus,
	onBlur,
	onKeyDown,
	autoFocus,
}) => {
	const options = formItem.itemOptions?.list?.length === 2 ? formItem.itemOptions.list : defaultOptions
	const offOption = options[0]
	const onOption = options[1]
	const value = formData[formItem.name]
	const valueOnly = !!formItem.itemOptions?.features?.valueOnly

	const optionValue = (option: any) => option?.value ?? option
	const currentValue = value?.value ?? value

	const checked = useMemo(() => {
		if (value === undefined || value === null) return false
		return currentValue === optionValue(onOption)
	}, [value, currentValue, onOption])

	const handleChange = (nextChecked: boolean) => {
		const selected = nextChecked ? onOption : offOption
		onChange?.(formItem.name, valueOnly ? optionValue(selected) : selected)
	}

	return (
		<>
			<SwitchControl
				checked={checked}
				disabled={disabled}
				checkedLabel={onOption.label}
				uncheckedLabel={offOption.label}
				className={formItem.classNames?.content}
				onChange={handleChange}
				onFocus={onFocus as React.FocusEventHandler<HTMLButtonElement>}
				onBlur={onBlur as React.FocusEventHandler<HTMLButtonElement>}
				onKeyDown={onKeyDown as React.KeyboardEventHandler<HTMLButtonElement>}
				autoFocus={autoFocus}
			/>
			{formItem.itemOptions?.description && (
				<div className="text-text-md text-gray-400">{formItem.itemOptions.description}</div>
			)}
			<ValidationError error={validation} formItem={formItem} />
		</>
	)
}

export default Switch
